import PhotoEntity from "./models/photo-entity"
import PhotosRepository from "./repository/photos-repository"
import PhotosService from "./repository/photos-service"
import PhotosStorage from "./repository/photos-storage"
import PhotosBloc from "./bloc/photos-bloc"
import View from "./view/view"
import UserRepository from "./repository/user-repository"

class GalleryPhotoComponent {
  constructor({ htmlElement, token, location, memberMode = false, loggedIn = false }) {
    const currentPhoto = PhotoEntity.fromHtmlElement(htmlElement)

    this._photosRepository = new PhotosRepository({
      service: new PhotosService(token, location),
      storage: new PhotosStorage(currentPhoto),
    })
    this._userRepository = new UserRepository({ memberMode, loggedIn })

    this._bloc = new PhotosBloc({
      currentPhoto,
      build: this.build.bind(this),
      userRepository: this._userRepository,
      photosRepository: this._photosRepository,
    })

    this._view = new View(this._bloc, htmlElement, location, token)
  }

  get state() {
    return this._bloc.state
  }

  async preload(photoId) {
    await this._photosRepository.preload(photoId)
    // Update state after preloading
    this._bloc.update(
      this._bloc.state.copyWith({
        backwardPhoto: this._photosRepository.loadFromStorage({
          photoId: this._bloc.state.currentPhoto.id,
          direction: "backward",
        }),
        forwardPhoto: this._photosRepository.loadFromStorage({
          photoId: this._bloc.state.currentPhoto.id,
          direction: "forward",
        }),
      }),
    )
  }

  build(state) {
    this._view.update(state)
  }
}

export default GalleryPhotoComponent
